import React from "react";

/**
 * Catches render/lifecycle errors anywhere below it so a single thrown error
 * shows a readable message instead of a blank white page.
 *
 * Note: this does NOT catch errors thrown at module-evaluation time (before
 * React mounts) — those must be prevented at the source, e.g. src/firebase.js.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="h-screen flex flex-col justify-center items-center bg-[#efede7] px-6 text-center">
        <h3 className="text-xl font-semibold text-[#c66a10]">
          Something went wrong
        </h3>
        <p className="mt-2 text-sm text-[#8e4d0e]">
          Please reload the page. If it keeps happening, try another browser or
          clear this site&apos;s data.
        </p>
        <button
          className="mt-5 rounded-3xl bg-[#c66a10] px-6 py-2 text-white"
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
        <pre className="mt-5 max-w-full overflow-x-auto whitespace-pre-wrap text-[10px] text-gray-500">
          {String(this.state.error?.message || this.state.error)}
        </pre>
      </div>
    );
  }
}

export default ErrorBoundary;
